{
    "LoadingLabel": "[Carregando...]",
    "NAME": "ComboBox"
}